// Lib
import React from 'react';
import { get } from 'lodash/fp';

// Components
import ElementDragPreview from './ElementDragPreview';
import DebugUIPoint from '../../debug/ui/DebugUIPoint';
import DebugUILineVector from '../../debug/ui/DebugUILineVector';

// Types
import { ImMNElement } from 'src/common/elements/elementModelTypes';
import { DraggedItem } from 'src/client/canvas/dnd/dragTypes';
import type { DebugToolSettings, DebugTools } from 'src/client/debug/store/debugToolTypes';

// Utils
import { getElementId } from '../../../common/elements/utils/elementPropertyUtils';
import { getTranslationStyles } from '../../utils/cssUtil';

// Styles
import './ElementDragPreviewPositioner.scss';

export type ElementDragPreviewPositionerProps = {
    // Optional for purely presentational previews (e.g. the card clipper's mousedown preview)
    elementId?: string;
    element: ImMNElement;
    gridSize: number;
    currentBoardId: string;
    permissions?: number;
    item: DraggedItem;
    zoomScaleOnDragSource?: number;
    dndDebugToolProperties?: DebugToolSettings[DebugTools.DND];
};

class ElementDragPreviewPositioner extends React.Component<ElementDragPreviewPositionerProps> {
    shouldComponentUpdate() {
        return false;
    }

    render() {
        const {
            element,
            elementId,
            item,
            gridSize,
            currentBoardId,
            permissions,
            zoomScaleOnDragSource,
            dndDebugToolProperties,
        } = this.props;

        const unscaledElementOffset = get(['unscaledElementOffsetsMap', getElementId(element)], item);
        const style = unscaledElementOffset ? getTranslationStyles(unscaledElementOffset) : null;

        const debugShowElementOffset = dndDebugToolProperties?.showElementOffset;
        const debugShowElementDragPreviewPositioner = dndDebugToolProperties?.showElementDragPreviewPositioner;

        return (
            <div className="ElementDragPreviewPositioner" style={style}>
                {debugShowElementDragPreviewPositioner && (
                    <DebugUIPoint color="var(--debug-ui-point-element-drag-preview-positioner-color)" />
                )}

                {unscaledElementOffset && debugShowElementOffset && (
                    <DebugUILineVector
                        vector={unscaledElementOffset}
                        color="var(--debug-ui-line-element-offset-color)"
                    />
                )}

                <ElementDragPreview
                    permissions={permissions}
                    currentBoardId={currentBoardId}
                    elementId={elementId}
                    element={element}
                    isPresentational
                    gridSize={gridSize}
                    zoomScaleOnDragSource={zoomScaleOnDragSource}
                />
            </div>
        );
    }
}

export default ElementDragPreviewPositioner;
